import type { Image } from "#src/index.ts";

// Real photos from picsum.photos. The `/seed/<seed>` endpoint returns a
// deterministic image for any seed string, so the set is stable across
// reloads and never 404s (unlike `/id/<n>`, whose ids have gaps). The
// width/height match each requested size so the grid's aspect-ratio math
// lines up with the actual image. Needs a network connection when running.
function picsum(seed: string, width: number, height: number): Image {
  return {
    src: `https://picsum.photos/seed/${seed}/${width}/${height}`,
    width,
    height,
  };
}

// A deliberately mixed set of aspect ratios (wide, tall, square, panoramic)
// so row balancing has something interesting to do.
export const images: Image[] = [
  picsum("grid-01", 400, 300),
  picsum("grid-02", 300, 400),
  picsum("grid-03", 600, 240),
  picsum("grid-04", 320, 320),
  picsum("grid-05", 500, 280),
  picsum("grid-06", 260, 380),
  picsum("grid-07", 640, 320),
  picsum("grid-08", 360, 300),
  picsum("grid-09", 420, 300),
  picsum("grid-10", 300, 300),
];

export interface Photo {
  label: string;
  preview: Image;
}

// Rich items for the @items + @key demo: each carries its own label
// alongside the nested image the grid lays out.
export const photos: Photo[] = [
  { label: "Mountains", preview: picsum("photo-mountains", 400, 300) },
  { label: "Forest", preview: picsum("photo-forest", 300, 380) },
  { label: "Harbour", preview: picsum("photo-harbour", 600, 260) },
  { label: "Desert", preview: picsum("photo-desert", 340, 320) },
  { label: "Coast", preview: picsum("photo-coast", 520, 300) },
  { label: "City", preview: picsum("photo-city", 300, 400) },
];
